<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M14.8955 7.62944C14.7705 7.44063 11.7648 3 8.00001 3C4.23527 3 1.22954 7.44063 1.10455 7.62944C0.96515 7.84048 0.96515 8.15952 1.10455 8.37056C1.22954 8.55937 4.23532 13 8.00001 13C11.7647 13 14.7705 8.55937 14.8955 8.37056C15.0348 8.15952 15.0348 7.84048 14.8955 7.62944Z"
        stroke="var(--icon-color)" stroke-width="1.5" />
    <path
        d="M5 8C5 9.60808 6.47358 11 8 11C9.52642 11 11 9.60808 11 8C11 6.39192 9.52643 5 8.00001 5C6.47359 5 5 6.39192 5 8Z"
        fill="var(--icon-color)" />
</svg>
